import { Controller } from "@hotwired/stimulus";

// Revenue Pace timeline: markers with hover tooltips, entrance animation.
// Bar represents revenue progress (0 → goal). Markers: current, goal pace, projected, last month.
export default class extends Controller {
  connect() {
    this.animateMarkers();
  }

  showTooltip(event) {
    const marker = event.currentTarget;
    const tooltipId = marker.dataset.tooltipId;
    const tooltip = tooltipId ? this.element.querySelector(`[data-revenue-tooltip="${tooltipId}"]`) : null;
    if (tooltip) {
      tooltip.classList.remove("opacity-0", "invisible");
      tooltip.classList.add("opacity-100", "visible");
    }
  }

  hideTooltip(event) {
    const marker = event.currentTarget;
    const tooltipId = marker.dataset.tooltipId;
    const tooltip = tooltipId ? this.element.querySelector(`[data-revenue-tooltip="${tooltipId}"]`) : null;
    if (tooltip) {
      tooltip.classList.add("opacity-0", "invisible");
      tooltip.classList.remove("opacity-100", "visible");
    }
  }

  animateMarkers() {
    const projected = this.element.querySelector('[data-marker="projected"]');
    if (projected) {
      projected.style.opacity = "0";
      projected.style.transform = "translateX(-8px)";
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          projected.style.transition = "opacity 0.5s ease-out, transform 0.5s ease-out";
          projected.style.opacity = "1";
          projected.style.transform = "translateX(0)";
        });
      });
    }

    const markers = this.element.querySelectorAll('[data-marker]:not([data-marker="projected"])');
    markers.forEach((m, i) => {
      m.style.opacity = "0";
      m.style.transform = "scale(0.8)";
      const delay = 80 * (i + 1);
      setTimeout(() => {
        m.style.transition = "opacity 0.35s ease-out, transform 0.35s ease-out";
        m.style.opacity = "1";
        m.style.transform = "scale(1)";
      }, delay);
    });
  }
}
